import React, { Component } from 'react'
import { purchase, createSubscription } from "~/views/Popup/popup";
import { getLocalizedVal } from '~/tools/localization/helpers'
import { addVideoPurchase } from '~/redux/purchaseInProcess/helper'
import purchaseStore from '~/redux/purchaseInProcess/store'
import get from 'lodash/get';

class OverlayItems extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: 0
    }
    this.handleClick = this.handleClick.bind(this);
  } 
  selected(i) {
    this.setState({
      selected: i
    })
  }

  componentDidMount() {
    const url = new URLSearchParams(window.location.search);
    if (url && url.get('overlay') && !this.props.subscriptionPlans){
      purchase(this.props.items[this.state.selected], this.props.content, this.props.watchNow, this.props.purchased);
    } else {
      this.renderPurchaseInProcess();
    }
  }
  renderPurchaseInProcess = () => {
    const ps = purchaseStore.getState();
    const psId = get(ps, "id.content");
    if(ps && ps.value && ps.modalType && ps.selected && psId){
      const id = get(this.props, "content.gist.id");
      let isSelectedContentValid = false;
      if (this.props && this.props.bundleOverlay){
        const { content = null, items = [] } = get(this.props, "content.gist.id") || {};
        isSelectedContentValid = psId === content || (items && items && [...items].findIndex(contentItem => ps.id.content === contentItem) !== -1);
      } else {
        isSelectedContentValid = psId === id;
      }
      if (!isSelectedContentValid) return;
      switch (ps.modalType){
        case "createSubscription":
          createSubscription(ps.selected.id, this.props.type);
          break;
        case "purchase":
          const { content: psContentItem = null } = ps.args || {}
          purchase(ps.selected, psContentItem || this.props.content, this.props.watchNow, this.props.purchased, this.props.type)
          break;
        default:
          break;
      }
    }
  }
  handleClick = () => {
    let contentId = get(this.props, "content.gist.id");
    contentId = typeof contentId === "object" ? contentId : { content: contentId };
    addVideoPurchase({
      value: true, 
      selected: this.props.items[this.state.selected],
      modalType: this.props.subscriptionPlans ? "createSubscription" : "purchase",
      id: contentId
    });

    return this.props.subscriptionPlans ? 
    createSubscription(this.props.items[this.state.selected].id, this.props.type) : 
    purchase(this.props.items[this.state.selected], this.props.content, this.props.watchNow, this.props.purchased, this.props.type)
  }
  render() {
    return (
      <div className={`overlay-video ${this.props.bundleOverlay ? 'overlay-bundle' : ''}`}>
        <div className="overlay-title">
          <span>{this.props.title}</span>
        </div>
        { this.props.warning && <div className='warning'>{this.props.warning}</div> }
        <div className="overlay-body">
          <div className="overlay-body-plans">
            {
              this.props.items && this.props.items.map((item, i) => {
                return (
                  <div className={`plan ${(this.state.selected === i) ? 'selected' : ''} `} onClick={(e) => this.selected(i)} key={i}>
                    <div className="side-bar"></div>
                    <div className="plan-body">
                      <p className="title">{item.name}</p>
                    </div>
                  </div>
                )
              })
            }
          </div>
          <div 
            className="overlay-button cta" 
            onClick={this.handleClick}
          >
            <button>{getLocalizedVal(window.settings,'genericMessages', 'continueCta')} { this.props.warning ? getLocalizedVal(window.settings,'genericMessages', 'warningCta') : '' }</button>
          </div>
        </div>
      </div>
    )
  }
}

export default OverlayItems